import cn from 'classnames';
import React from 'react';

import { H2 } from 'components/basic/Typography';
import Page from 'components/layouts/Page';
import Menu from 'components/pagesComponents/landing/Main/components/Menu';

import s from './category.module.scss';

const seo = {
  title: 'Device Pairings For Welltory App',
  description:
    'Learn which devices you can pair with Welltory for the ultimate wellness and stress relief experience.',
    canonical: 'https://welltory.com/devices/',
};
const iOS = [
  {
    text: 'Apple Watch HRV App',
    href: 'https://welltory.com/devices/apple-watch-hrv-app/',
  },
  {
    text: 'Apple Watch Heart Rate Monitor',
    href: 'https://welltory.com/devices/heart-rate-monitor-apple-watch/',
  },
  {
    text: 'Apple Watch Stress Monitor',
    href: 'https://welltory.com/devices/apple-watch-stress-monitor/',
  },
  {
    text: 'Health Monitor App',
    href: 'https://welltory.com/devices/health-monitor-app/',
  },
  {
    text: 'Heart Health App',
    href: 'https://welltory.com/devices/heart-health-app/',
  },
  {
    text: 'Heart Monitor App',
    href: 'https://welltory.com/devices/heart-monitor-app/',
  },
  {
    text: 'HRV Tracker App',
    href: 'https://welltory.com/devices/hrv-tracker-app/',
  },
  {
    text: 'iPhone Heart Rate App',
    href: 'https://welltory.com/devices/iphone-heart-rate-app/',
  },
  {
    text: 'Stress App',
    href: 'https://welltory.com/devices/stress-app/',
  },
  {
    text: 'Stress Management App',
    href: 'https://welltory.com/devices/stress-management-app/',
  },
  {
    text: 'Welltory Productivity App',
    href: 'https://welltory.com/devices/productivity-app/',
  },
  {
    text: 'Welltory x RescueTime',
    href: 'https://welltory.com/devices/welltory-rescuetime/',
  },
];
const android = [
  {
    text: 'Android Heart Rate App',
    href: 'https://welltory.com/devices/android-heart-rate-app/',
  },
  {
    text: 'Android HRV App',
    href: 'https://welltory.com/devices/android-hrv-app/',
  },
  {
    text: 'Fitbit HRV App',
    href: 'https://welltory.com/devices/fitbit-hrv-app/',
  },
  {
    text: 'Galaxy Watch HRV App',
    href: 'https://welltory.com/devices/galaxy-watch-hrv-app/',
  },
  {
    text: 'Garmin Heart Rate Monitor App',
    href: 'https://welltory.com/devices/garmin-heart-rate-monitor-app/',
  },
  {
    text: 'Garmin HRV App',
    href: 'https://welltory.com/devices/garmin-hrv-app/',
  },
  {
    text: 'Samsung Watch Stress App',
    href: 'https://welltory.com/devices/samsung-watch-stress/',
  },
];

export const DeviceCategory: React.FC = () => {
  return (
    <Page withoutHeader fullFooter fullWidth seo={seo}>
      <Menu />
      <H2 className="text-center">Welltory Device Pairing</H2>
      <div className={cn(s.container, 'text-center')}>
        <div className={s.ios}>
          <p>iOS & Apple Watch</p>
          {iOS.map(({ href, text }) => (
            <p key={href}>
              —{' '}
              <a href={href} className={s.link}>
                {text}
              </a>
            </p>
          ))}
        </div>
        <div className={s.android}>
          <p>Android | Samsung | Garmin | Others</p>
          {android.map(({ href, text }) => (
            <p key={href}>
              —{' '}
              <a href={href} className={s.link}>
                {text}
              </a>
            </p>
          ))}
        </div>
      </div>
    </Page>
  );
};
